module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANBAMAAACX52mGAAAAJFBMVEUAAABmZmZnZ2d3d3ebm5ucnJydnZ2qqqqrq6vY2Nj19fX7+/s404IIAAAAAXRSTlMAQObYZgAAADFJREFUCNdjYACDbRuARGMBAwOnoiYDw2JB4QUMgYKCAQwI4Cgo6ACRACthKCyAaAMAHuQJedzrfqAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/sort.png
// module id = 605
// module chunks = 0